import DummyScreen from '@src/screens/Dummy';

export default DummyScreen;
